module.exports = __webpack_public_path__ + "img/5.b3c59d04.jpg";